import ErrorFallback from './error-fallback';

export default ErrorFallback;